import { render, staticRenderFns } from "./CompetencyExam.vue?vue&type=template&id=4c4ca74a"
import script from "./CompetencyExam.vue?vue&type=script&lang=js"
export * from "./CompetencyExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports